import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import ProgressBar from 'components/Widgets/ProgressBar';
import { useContext as useUsersContext } from 'components/Users/Context';
import useAffiliateTrainingSteps from 'components/Common/AffiliateTrainingSteps/Hooks/useAffiliateTrainingSteps';

import TrainingStep from './TrainingStep';
import Certificate from './Certificate';

export default function Index() {
  const { state: stateUsers } = useUsersContext();
  const affiliateTrainingSteps = useAffiliateTrainingSteps();

  const affiliate = stateUsers.user.attributes.specific;

  function dateFormat(value) {
    const date = new Date(value);
    const options = {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    };

    return date.toLocaleDateString('en-US', options);
  }

  return (
    <div className="content">
      <section>
        <h1 className="mb-3">Certification Training</h1>

        <Row className="mb-5 align-items-center">
          <Col md={6} lg={4} className="mb-4 fw-light text-gray-800">
            Started on:
            {' '}
            {dateFormat(affiliate.training_approved_at)}
          </Col>

          <Col md={6} lg={4} className="mb-4 fw-light text-gray-800">
            Updated on:
            {' '}
            {dateFormat(affiliate.training_updated_at)}
          </Col>

          <Col lg={4} xl={{ span: 3, offset: 1 }} className="mb-4">
            <ProgressBar now={affiliate.training_completion} />
          </Col>
        </Row>

        {affiliateTrainingSteps === null ? (
          <LoadingPlaceholder text="Loading..." />
        ) : (
          <>
            <ul className="with-counter big-counter-icons">
              {affiliateTrainingSteps.map((trainingStep, index) => (
                <TrainingStep key={trainingStep.id} trainingStep={trainingStep} index={index} />
              ))}
            </ul>

            <Certificate />
          </>
        )}
      </section>
    </div>
  );
}
